import { useCallback, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useClearTasks } from '../..';
import { IMAGE_MAPPER_BY_TASK_TYPE } from '../../../../helper/imageFileResolver';
import {
  actions as tasksActions,
  selectors as tasksSelectors,
} from '../../../../store/tasks';

const useCreateTask = () => {
  const createTaskIsFetching = useSelector(
    tasksSelectors.selectCreateTaskIsFetching,
  );

  const createTaskSuccess = useSelector(tasksSelectors.selectCreateTaskSuccess);

  const createTaskError = useSelector(tasksSelectors.selectCreateTaskError);

  const dispatch = useDispatch();

  const createTask = useCallback(
    (values) => {
      const data = IMAGE_MAPPER_BY_TASK_TYPE[values.type](values);
      dispatch(tasksActions.createTaskRequest(data));
    },
    [dispatch],
  );

  const clearTasks = useClearTasks();

  useEffect(
    () => () => {
      clearTasks();
    },
    [clearTasks],
  );

  return {
    createTask,
    createTaskIsFetching,
    createTaskSuccess,
    createTaskError,
    clearTasks,
  };
};

export default useCreateTask;
